import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const url = process.env.REACT_APP_URL;
const LogoutButton = () => {
  const { isAuthenticated, logout } = useAuth0();

  return (
    isAuthenticated && (
      <button
        className="btn"
        onClick={() => {
          logout({ returnTo: url + "/login" });
        }}
      >
        Log out
      </button>
    )
  );
};

export default LogoutButton;
